<template>
  <div>
    <div class="pageTitleController">
      <img src="@/assets/img/7.png" />
      <div class="marginLeft15" v-if="!type">企业基本信息</div>
      <div class="marginLeft15" v-else>所代理的生产商资料</div>
    </div>
    <!--企业信息列表的切换条-->
    <ListTab
      v-if="!save"
      :act="type === null ? '2' : '1'"
      class="marginTop20"
    ></ListTab>
    <!-----------------------------------------------------------下面是填写详情（表单）-------------------------------->
    <div v-if="save">
      <Plan :title="`填写资质详情`" class="marginTop20">
        <div class="total">
          <div class="item">
            <div class="titleOverAll"><span class="red">*</span>企业名称</div>
            <el-input
              v-model="infoForm.company_name"
              placeholder="请填写企业名称"
              class="width320"
            ></el-input>
          </div>
          <div class="item marginLeft40">
            <div class="titleOverAll"><span class="red">*</span>企业类型</div>
            <el-select
              v-model="infoForm.company_cate"
              placeholder="请选择企业类型"
              class="width320"
            >
              <el-option
                v-for="(val, ind) in fenlei"
                :key="ind"
                :label="val.name"
                :value="val.id"
              ></el-option>
            </el-select>
          </div>
          <div class="item marginLeft40">
            <div class="titleOverAll">
              <span class="red">*</span>统一社会信用代码
            </div>
            <el-input
              :disabled="profile_step === 2"
              v-model="infoForm.social_code"
              placeholder="请填写统一社会信用代码"
              class="width320"
            ></el-input>
          </div>
        </div>
        <div class="total marginTop40">
          <div class="item">
            <div class="titleOverAll">
              <span class="red">*</span>注册资金（万元）
            </div>
            <div>
              <el-input
                style="width: 200px;"
                type="number"
                v-model="infoForm.reg_capital"
                placeholder="请填写注册资金（万元），例如：100"
              ></el-input>
              <el-select
                style="width: 100px; margin-left: 20px;"
                v-model="infoForm.reg_unit"
                placeholder="请选择"
              >
                <el-option value="人民币" label="人民币">人民币</el-option>
                <el-option value="美元" label="美元">美元</el-option>
                <el-option value="港元" label="港元">港元</el-option>
              </el-select>
            </div>
          </div>
          <div class="item marginLeft40">
            <div class="titleOverAll"><span class="red">*</span>法定代表人</div>
            <el-input
              v-model="infoForm.legal_name"
              placeholder="请填写法定代表人"
              class="width320"
            ></el-input>
          </div>
          <div class="item marginLeft40">
            <div class="titleOverAll">
              <span class="red">*</span>法定代表人联系电话
            </div>
            <el-input
              v-model="infoForm.legal_tel"
              placeholder="请填写电话"
              class="width320"
            ></el-input>
          </div>
        </div>
        <div class="total marginTop40">
          <div class="item">
            <div class="titleOverAll">
              <span class="red">*</span>企业注册地址
            </div>
            <div class="flexAre">
              <Areselect v-model="areCodeList"></Areselect>
              <el-input
                v-model="infoForm.register_address"
                class="width320 marginLeft40"
                placeholder="请填写企业详细注册地址"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="total marginTop40">
          <div class="titleOverAll" style="flex:1;">
            <span class="red">*</span>营业执照（彩色扫描件）
          </div>
        </div>
        <div class="total marginTop40">
          <div style="flex:1;display:flex;">
            <Up :length="1" v-model="yinyezhizhao" title="点击上传"></Up>
            <div v-if="yinyezhizhao.length === 1" class="upShowController">
              <el-image
                :preview-src-list="[yinyezhizhao[0].viewurl]"
                class="upCoerImg"
                :src="yinyezhizhao[0].viewurl"
              />
              <i @click="yinyezhizhao = []" class="el-icon-delete del"></i>
            </div>
            <div slot="tip" class="el-upload__tip marginLeft10">
              （文件支持多种格式上传，包括png/jpg/pdf/doc，大小不超过4M）
            </div>
          </div>
        </div>
      </Plan>
      <Plan :title="`企业通讯信息`" class="marginTop20">
        <div class="total marginTop40">
          <!-- <div class="item" v-if="false">
          <div class="ttitleOverAll"><span class="red">*</span>联系人</div>
          <el-input
            v-model="infoForm.contact_person"
            placeholder="请填写联系人"
            class="width320"
          ></el-input>
        </div> -->

          <!-- 经办人输入框 -->
          <div class="item">
            <div class="titleOverAll"><span class="red">*</span>经办人</div>
            <el-input
              v-model="infoForm.contact_person"
              placeholder="请填写经办人"
              class="width320"
            ></el-input>
          </div>
          <!-- 完 -->

          <!-- <div class="item marginLeft40" v-if="false">
          <div class="titleOverAll"><span class="red">*</span>联系人电话</div>
          <el-input placeholder="请填写联系人电话" class="width320"></el-input>
        </div> -->

          <!-- 经办人电话输入框 -->
          <div class="item marginLeft40">
            <div class="titleOverAll"><span class="red">*</span>经办人电话</div>
            <el-input
              v-model="infoForm.contact_tel"
              placeholder="请填写经办人联系电话"
              class="width320"
            ></el-input>
          </div>
          <div class="item marginLeft40">
            <div class="titleOverAll"><span class="red">*</span>微信号</div>
            <el-input
              v-model="infoForm.wx_number"
              placeholder="微信号"
              class="width320"
            ></el-input>
          </div>
        </div>
        <div class="total marginTop40">
          <div class="item">
            <div class="titleOverAll"><span class="red">*</span>通信地址</div>
            <el-input
              v-model="infoForm.contact_address"
              placeholder="请填写联系地址"
              class="width320"
            ></el-input>
          </div>
        </div>
      </Plan>
      <Plan :title="`企业资料库`" class="marginTop20">
        <div class="total marginTop40">
          <div class="item">
            <div class="titleOverAll">
              建厂环评批复文件
            </div>
            <UpFile
              v-model="infoForm.factory_comment"
              class="width320"
            ></UpFile>
          </div>
          <div class="item marginLeft40">
            <div class="titleOverAll">质量管理体系认证证书</div>
            <UpFile
              v-model="infoForm.quality_control"
              class="width320"
            ></UpFile>
          </div>
          <div class="item marginLeft40">
            <div class="titleOverAll">环境管理体系认证证书</div>
            <UpFile
              v-model="infoForm.environment_cert"
              class="width320"
            ></UpFile>
          </div>
        </div>
        <div class="total marginTop40">
          <div class="item">
            <div class="titleOverAll">能源管理体系认证证书</div>
            <UpFile v-model="infoForm.energy_cert" class="width320"></UpFile>
          </div>
          <div class="item marginLeft40">
            <div class="titleOverAll">职业健康安全管理体系认证证书</div>
            <UpFile
              v-model="infoForm.profession_cert"
              class="width320"
            ></UpFile>
          </div>
          <div class="item marginLeft40">
            <div class="titleOverAll">工作场所有害因素第三方检测报告</div>
            <UpFile v-model="infoForm.workplace_cert" class="width320"></UpFile>
          </div>
        </div>
        <div class="total marginTop40">
          <div class="item">
            <div class="titleOverAll">商标注册证</div>
            <UpFile v-model="infoForm.trademark_cert" class="width320"></UpFile>
          </div>
          <div class="item marginLeft40">
            <div class="titleOverAll">排污许可证</div>
            <UpFile v-model="infoForm.sewage_cert" class="width320"></UpFile>
          </div>
          <div class="item marginLeft40">
            <div class="titleOverAll">其它资质荣誉证书</div>
            <UpFile v-model="infoForm.other_cert" class="width320"></UpFile>
          </div>
        </div>
      </Plan>
      <div class="flexTextCenter">
        <div @click="sub('submit')" class="saveBtnController">确认</div>
      </div>
    </div>
    <!------------------------------------------------------------下面是显示详情------------------------------->
    <div v-if="!save" class="marginTop20">
      <Accordion :title="`${infoForm.company_name}-资料详情`" :show="true">
        <div class="componyInfoMainController">
          <!--审核状态-->
          <div
            style="position: relative;"
            v-if="
              profile_step === 2 || profile_step === 3 || profile_step === 4
            "
          >
            <!--审核状态-->
            <div class="shenhezhaungtai">
              <div class="zhaungtaiTitle">审核状态</div>
              <div class="zhaungtaiInfo tel">
                {{ info.step_text }}
              </div>
              <div
                v-if="(info.profile_step = 1)"
                style="    color: red;    position: absolute;    right: 0px;"
              >
                企业信息审核通过后，您需要提交产品信息完成信息登记
              </div>
            </div>
            <!--审核状态-->
            <div v-if="profile_step === 3" class="shenhezhaungtai marginTop20">
              <div class="zhaungtaiTitle">反馈意见</div>
              <div class="zhaungtaiInfo tel">
                {{ check_mark }}
              </div>
            </div>
          </div>
          <div v-if="parseInt(info.hascode) === 1">
            <!-- 证书查看和下载 -->
            <div class="bookControll">
              <div class="bookName" :title="info.hascode">
                《云南省建设工程材料及设备信息登记卡》
              </div>
              <div class="bookup" @click="lockCertificate(info.uuid)">
                查看证书
              </div>
              <div class="bookup" @click="downCertificate(info.uuid)">
                下载证书
              </div>
              <div class="bookup" @click="printCertificate(info.uuid)">
                打印证书
              </div>
            </div>
            <div class="lines"></div>
          </div>
          <!--第一个区域-->
          <div class="componyInfoController marginTop20">
            <div class="aCompony">
              <div class="titles">企业名称</div>
              <div class="des marginTop20">{{ infoForm.company_name }}</div>
            </div>
            <div class="aCompony">
              <div class="titles">企业类型</div>
              <div class="des marginTop20">
                {{ showComponytype }}
              </div>
            </div>
            <div class="aCompony">
              <div class="titles">统一社会信用代码</div>
              <div class="des marginTop20">{{ infoForm.social_code }}</div>
            </div>
            <div class="aCompony">
              <div class="titles">注册资金（万元）</div>
              <div class="des marginTop20">
                {{ infoForm.reg_capital }}{{ infoForm.reg_unit }}
              </div>
            </div>
            <div class="aCompony">
              <div class="titles">法定代表人</div>
              <div class="des marginTop20">{{ infoForm.legal_name }}</div>
            </div>
            <div class="aCompony">
              <div class="titles">法定代表人联系电话</div>
              <div class="des marginTop20">{{ infoForm.legal_tel }}</div>
            </div>
            <div class="aCompony">
              <div class="titles">企业注册地址</div>
              <div class="des marginTop20">
                <div class="flexAre">
                  <Areselect :onlyshow="true" v-model="areCodeList"></Areselect>
                  {{ infoForm.register_address }}
                </div>
              </div>
            </div>
            <div v-if="yinyezhizhao[0]" class="aCompony">
              <div class="titles">营业执照（彩色扫描件）</div>
              <div class="des marginTop20">
                <a
                  :href="yinyezhizhao[0].viewurl"
                  target="_blank"
                  style="color:#00B1FF;"
                >
                  营业执照（彩色扫描件）.JPG
                </a>
              </div>
            </div>
          </div>
          <div class="lines"></div>
          <!--第二个区域-->
          <div class="componyInfoController">
            <div class="aCompony">
              <div class="titles">经办人</div>
              <div class="des marginTop20">{{ infoForm.contact_person }}</div>
            </div>
            <div class="aCompony">
              <div class="titles">经办人电话</div>
              <div class="des marginTop20">{{ infoForm.contact_tel }}</div>
            </div>
            <div class="aCompony">
              <div class="titles">微信号</div>
              <div class="des marginTop20">{{ infoForm.wx_number }}</div>
            </div>
          </div>
          <div class="componyInfoController">
            <div class="aCompony">
              <div class="titles">通信地址</div>
              <div class="des marginTop20">{{ infoForm.contact_address }}</div>
            </div>
          </div>
          <!-- 第三个区域 企业资料库 -->
          <div class="total marginTop40">
            <div class="item">
              <div class="titleOverAll">
                建厂环评批复文件
              </div>
              <UpFile
                :onlyshow="onlyshow"
                v-model="infoForm.factory_comment"
                class="width320"
              ></UpFile>
            </div>
            <div class="item marginLeft40">
              <div class="titleOverAll">质量管理体系认证证书</div>
              <UpFile
                :onlyshow="onlyshow"
                v-model="infoForm.quality_control"
                class="width320"
              ></UpFile>
            </div>
            <div class="item marginLeft40">
              <div class="titleOverAll">环境管理体系认证证书</div>
              <UpFile
                :onlyshow="onlyshow"
                v-model="infoForm.environment_cert"
                class="width320"
              ></UpFile>
            </div>
          </div>
          <div class="total marginTop40">
            <div class="item">
              <div class="titleOverAll">能源管理体系认证证书</div>
              <UpFile
                :onlyshow="onlyshow"
                v-model="infoForm.energy_cert"
                class="width320"
              ></UpFile>
            </div>
            <div class="item marginLeft40">
              <div class="titleOverAll">职业健康安全管理体系认证证书</div>
              <UpFile
                :onlyshow="onlyshow"
                v-model="infoForm.profession_cert"
                class="width320"
              ></UpFile>
            </div>
            <div class="item marginLeft40">
              <div class="titleOverAll">工作场所有害因素第三方检测报告</div>
              <UpFile
                :onlyshow="onlyshow"
                v-model="infoForm.workplace_cert"
                class="width320"
              ></UpFile>
            </div>
          </div>
          <div class="total marginTop40">
            <div class="item">
              <div class="titleOverAll">商标注册证</div>
              <UpFile
                :onlyshow="onlyshow"
                v-model="infoForm.trademark_cert"
                class="width320"
              ></UpFile>
            </div>
            <div class="item marginLeft40">
              <div class="titleOverAll">排污许可证</div>
              <UpFile
                :onlyshow="onlyshow"
                v-model="infoForm.sewage_cert"
                class="width320"
              ></UpFile>
            </div>
            <div class="item marginLeft40">
              <div class="titleOverAll">其它资质荣誉证书</div>
              <UpFile
                :onlyshow="onlyshow"
                v-model="infoForm.other_cert"
                class="width320"
              ></UpFile>
            </div>
          </div>
          <!--按钮-->
          <div class="btnController marginTop20" v-if="profile_step !== 4">
            <div class="yuanLouKongBtn" @click="save = true">修改资料</div>
          </div>
        </div>
      </Accordion>
    </div>
  </div>
</template>

<script>
import Api from "@/plugins/axios.js";
import Accordion from "@/components/Accordion.vue";
import Areselect from "@/components/Areselect.vue";
import ListTab from "@/components/ListTab.vue";
import Up from "@/components/Up.vue";
import UpFile from "@/components/UpFile.vue";
import Plan from "@/components/Plan.vue";
import { Loading } from "element-ui";
// import Accordion from "@/components/Accordion.vue";
export default {
  components: {
    Accordion,
    Areselect,
    ListTab,
    Plan,
    Up,
    UpFile
  },
  data() {
    return {
      // 下面是审核信息显示的字段start
      profile_step: null, // 审核进度
      check_mark: null, // 审核备注信息
      // 下面是审核信息显示的字段end
      type: null, // 判断生产商资料还是其他的什么
      uuid: null, // 生产商资料修改模式下面的 UUID
      save: false, // 是否是修改模式
      fenlei: [], // 企业信息分类
      info: { hascode: null }, // 全部详细信息
      // 显示企业类型
      showComponytype: null,
      // 三级地址下拉
      areCodeList: [],
      // 提交的表单信息
      infoForm: {
        reg_unit: "人民币", // 注册资本单位
        company_name: "", // 企业名称
        company_cate: "", // 企业分类
        social_code: "", // 统一社会信用代码
        reg_capital: "", // 注册资本
        legal_name: "", // 法定代表人
        legal_tel: "", // 电话
        register_address: "", // 注册地址
        contact_person: "", // 联系人
        contact_tel: "", // 联系人电话
        contact_address: "", // 联系地址
        wx_number: "", // 联系地址，
        factory_comment: "",
        quality_control: "",
        environment_cert: "",
        energy_cert: "",
        profession_cert: "",
        workplace_cert: "",
        trademark_cert: "",
        sewage_cert: "",
        other_cert: ""
      },
      yinyezhizhao: [], // 营业执照
      weituoshu: [], // 委托书
      onlyshow: true
    };
  },
  mounted() {
    // 从路由中获得参数并初始化
    this.routeInit();
  },
  watch: {
    $route() {
      // 从路由中获得参数并初始化
      this.routeInit();
    }
  },
  methods: {
    // 下面是证书的三个方法
    lockCertificate(uuid) {
      this.$router.push({
        name: "Card",
        query: {
          uuid,
          agentType: 1,
          type: "look"
        }
      });
    },
    downCertificate(uuid) {
      this.$router.push({
        name: "Card",
        query: {
          uuid,
          agentType: 1,
          type: "down"
        }
      });
    },
    printCertificate(uuid) {
      this.$router.push({
        name: "Card",
        query: {
          uuid,
          agentType: 1,
          type: "print"
        }
      });
    },
    // 路由初始化
    async routeInit() {
      // 企业信息获得，用于操作顶部的导航条显示状态
      const re = await Api.userinfo(this.$store.state.token);
      this.$store.commit("SET_USERINFO", re);
      this.$store.commit("SET_USERID", re.id);

      // 传递模式
      if (this.$route.query.type) {
        this.type = this.$route.query.type;
        this.save = true;
      } else {
        this.type = null;
        this.save = false;
      }
      // 传递修改uuid
      if (this.$route.query.uuid) {
        this.uuid = this.$route.query.uuid;
      } else {
        this.uuid = null;
      }
      // 判断是自身的修改模式还是怎么说
      await this.getFlList();
      this.init();
    },
    // 获得企业分类
    async getFlList() {
      const li = await Api.getQyFl("business_class", 1);
      this.fenlei = li;
    },
    // 初始化查询
    async init() {
      const loadingInstance = Loading.service({ fullscreen: true });
      // 企业信息获得
      let info = null;
      if (this.type === null) {
        // 获得自己的信息
        info = await Api.userinfo(this.$store.state.token);
      } else if (this.uuid !== null) {
        // 获得代理商信息
        info = await Api.getAgent(this.$store.state.token, this.uuid);
      }
      if (info) {
        // 原始信息存储到全局
        this.info = info;
        // 审核信息
        this.profile_step = info.profile_step;
        // 备注信息
        this.check_mark = info.checkmark;
        // 判断编辑状态
        if (
          this.profile_step === 0 ||
          this.profile_step === 1 ||
          this.profile_step === 5
        ) {
          // 未提交状态直接进入编辑框
          this.save = true;
        }
      }

      // 处理三级下拉选择器
      if (info) {
        let arr = [];
        if (info.province_code) {
          arr[0] = info.province_code;
        }
        if (info.city_code) {
          arr[1] = info.city_code;
        }
        if (info.area_code) {
          arr[2] = info.area_code;
        }
        this.areCodeList = arr;
      } else {
        this.areCodeList = [];
      }

      // 计算显示用的企业类型
      if (info) {
        for (let index = 0; index < this.fenlei.length; index++) {
          const element = this.fenlei[index];
          if (parseInt(info.company_cate) === parseInt(element.id)) {
            // 显示的企业类型
            this.showComponytype = element.name;
          }
        }
      }
      if (info) {
      this.infoForm = {
        reg_unit: info ? info.reg_unit : "人民币",
        company_name: info ? info.company_name : "", // 企业名称
        company_cate: info ? info.company_cate : "", // 企业分类
        social_code: info ? info.social_code : "", // 统一社会信用代码
        reg_capital: info ? info.reg_capital : "", // 注册资本
        legal_name: info ? info.legal_name : "", // 法定代表人
        legal_tel: info ? info.legal_tel : "", // 电话
        register_address: info ? info.register_address : "", // 注册地址
        contact_person: info ? info.contact_person : "", // 联系人
        contact_tel: info ? info.contact_tel : "", // 联系人电话
        contact_address: info ? info.contact_address : "", // 联系地址
          wx_number: info ? info.wx_number : "", // 联系地址
          factory_comment: info ? info.factory_comment : "",
          quality_control: info.quality_control,
          environment_cert: info.environment_cert,
          energy_cert: info.energy_cert,
          profession_cert: info.profession_cert,
          workplace_cert: info.workplace_cert,
          trademark_cert: info.trademark_cert,
          sewage_cert: info.sewage_cert,
          other_cert: info.other_cert
      };
        console.log(this.infoForm, "");
      }
      if (info && info.business_license) {
        this.yinyezhizhao = [
          {
            name: "",
            url: info.business_license,
            viewurl: Api.domain + info.business_license
          }
        ];
      } else {
        this.yinyezhizhao = [];
      }
      if (info && info.agent_attorney) {
        this.weituoshu = [
          {
            name: "",
            url: info.agent_attorney,
            viewurl: Api.domain + info.agent_attorney
          }
        ];
      } else {
        this.weituoshu = [];
      }
      loadingInstance.close();
    },
    // 提交信息
    async sub(action) {
      if (this.areCodeList.length !== 3) {
        this.$msgbox({
          title: "提示",
          type: "error",
          message: "请选择企业注册地址"
        });
        return false;
      }
      let sendData = {
        province_code: this.areCodeList[0], // 省
        city_code: this.areCodeList[1], // 城市
        area_code: this.areCodeList[2], // 区域
        action,
        ...this.infoForm,
        business_license:
          this.yinyezhizhao.length === 1 ? this.yinyezhizhao[0].url : "",
        agent_attorney: this.weituoshu.length === 1 ? this.weituoshu[0].url : ""
      };

      // 判断是不是修改
      if (this.uuid) {
        sendData.id = this.uuid;
      }

      const loadingInstance = Loading.service({ fullscreen: true });
      try {
        Loading.service({ fullscreen: true });
        // 判断是不是生产厂商添加
        let agent = false;
        if (this.type !== null) {
          agent = true;
        }
        // 发出存储数据的请求
        await Api.saveProfile(this.$store.state.token, sendData, agent);
        this.$msgbox({ title: "提示", type: "success", message: "操作成功" });

        if (!agent) {
          // 重新加载数据
          this.routeInit();
        } else {
          // 跳转回到列表页
          this.$router.push({
            name: "InfoList"
          });
        }
      } catch (error) {
        this.$msgbox({ title: "提示", type: "error", message: error });
      }
      loadingInstance.close();
    }
  }
};
</script>
<style lang="less" scoped>
.flexTextCenter {
  text-align: center;
}
// 上传
.upShowController {
  position: relative;
  right: 0px;
  top: 0px;
  .del {
    position: absolute;
    top: 0px;
    right: 0px;
    color: red;
    font-size: 22px;
  }
}
.flexAre {
  display: flex;
  align-items: center;
}
// 企业信息显示详情
.componyInfoMainController {
  // 审核详情
  .shenheInfoController {
    .shenheTitle {
      padding: 16px 32px;
      font-size: 16px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      opacity: 1;
    }
    // 详情容器
    .shenheInfo {
      border-top: 1px solid rgba(230, 230, 230, 1);
      padding: 24px 32px;
      display: flex;
      .shenheCon {
        margin-left: 20px;
        .shenheTi {
          font-size: 12px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          opacity: 1;
        }
        .shenheDes {
          margin-top: 5px;
          font-size: 12px;
          font-weight: 400;
          color: #999999;
          opacity: 1;
        }
      }
    }
  }
  // 审核状态
  .shenhezhaungtai {
    padding: 12px 32px;
    display: flex;
    // 状态标题
    .zhaungtaiTitle {
      font-size: 14px;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      opacity: 1;
    }
    // 状态详情
    .zhaungtaiInfo {
      margin-left: 30px;
      font-size: 14px;
      font-weight: 400;
      opacity: 1;
    }
  }
  // 蓝色
  .tel {
    color: #00b1ff;
  }
  .shenheInfoController,
  .shenhezhaungtai {
    background-color: #f0f5f7;
    border-radius: 10px;
  }
  //证书查看下载
  .bookControll {
    display: flex;
    align-items: center;
    padding-top: 25px;
    .bookName {
      font-weight: 600;
      color: #213743;
      font-size: 20px;
      display: flex;
      align-items: center;
    }
    .bookup {
      color: rgb(0, 177, 255);
      margin-left: 30px;
      font-size: 14px;
      font-weight: 400;
      height: 20px;
      cursor: pointer;
      border-bottom: rgb(0, 177, 255) 2px solid;
    }
  }
  // 企业信息显示详情
  .componyInfoController {
    display: flex;
    flex-wrap: wrap;
    .aCompony {
      width: 33%;
      min-width: 33%;
      margin-top: 35px;
      // 标题
      .titles {
        font-size: 12px;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        opacity: 1;
      }
      // 描述
      .des {
        font-size: 12px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        opacity: 1;
        a {
          text-decoration: none;
          color: #00b1ff;
        }
      }
    }
    .aCompony:nth-child(1),
    .aCompony:nth-child(2),
    .aCompony:nth-child(3) {
      margin-top: 0px;
    }
  }
  .btnController {
    text-align: center;
  }
}
</style>
